import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=7c9daba8"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=7c9daba8&prod&lang=css"
import style1 from "./editor.vue?vue&type=style&index=1&id=7c9daba8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports